import React from 'react';
import Link from 'atomic/utilization/link';
import Price from 'atomic/utilization/price';
import Stars from 'atomic/utilization/stars';
import flectionNumeral from 'helpers/number';
import ProductListImpression from 'components/impressions/product-impression/list/product-list-impression';
import { RankedProductInterface } from 'interfaces/ranked-product.interface';

import './ranking-item.scss';

interface RankingItemProps {
    rankedProduct: RankedProductInterface;
}

const RankingItem: React.FC<RankingItemProps> = ({ rankedProduct }) => (
    <ProductListImpression trackedData={rankedProduct.product} className="ranked-item">
        <a className="ranked-item__link" href={rankedProduct.product.url} aria-label="link"/>
        <div className="ranked-item__rank">
            <div className="ranked-item__rank-value">
                {rankedProduct.position}
                <i className="icon-ranking-orange2"/>
            </div>
            {rankedProduct.previousPosition && (
                <div className="ranked-item__rank-trend">
                    {
                        rankedProduct.position < rankedProduct.previousPosition
                            ? (
                                <>
                                    <i className="icon-ranking-up"/>
                                    {rankedProduct.previousPosition - rankedProduct.position}
                                </>
                            )
                            : (rankedProduct.position > rankedProduct.previousPosition
                                ? (
                                    <>
                                        <i className="icon-ranking-down"/>
                                        {rankedProduct.position - rankedProduct.previousPosition}
                                    </>
                                )
                                : (
                                    <>
                                        <i className="icon-ranking-const"/>
                                        {0}
                                    </>
                                ))
                    }
                </div>
            )}
        </div>

        <div className="ranked-item__image">
            <img src={rankedProduct.product.mainPhotoUrl} alt={rankedProduct.product.name} loading={'lazy'}/>
        </div>

        <div className="ranked-item__info">
            <div className="ranked-item__info-title">
                {rankedProduct.product.name}
            </div>
            {rankedProduct.product.opinions?.count > 0 && (
                <div className="ranked-item__info-stars">
                    <Stars className={'xs star-rating--filled-orange'} width={rankedProduct.product.opinions.average}/>
                    {` od ${flectionNumeral(rankedProduct.product.opinions.count, ['klienta', 'klientów', 'klientów'])} `}
                </div>
            )}
            <p className="ranked-item__info-description">
                {rankedProduct.product.richDescription?.strippedContent}
            </p>
            {rankedProduct.product.offers.count > 1 && (
                <Link className="ranked-item__details-offers ranked-item__info-offers" href={rankedProduct.product.url}>
                    {flectionNumeral(rankedProduct.product.offers.count, ['oferta sklepu', 'oferty sklepów', 'ofert sklepów'])}
                </Link>
            )}
        </div>

        <div className="ranked-item__details">
            <div className="ranked-item__details-info">
                <span className="ranked-item__details-info__label">
                    Najniższa cena:
                </span>
                <Price price={rankedProduct.product.price} weight={'700'} size={'lg'}/>
            </div>
            <div className="ranked-item__details-info">
                <span className="ranked-item__details-info__label">
                    Sklep:
                </span>
                <span className="ranked-item__details-info__value">
                    {rankedProduct.product.offers.items[0].dealer.name}
                </span>
            </div>
            <a className="ranked-item__details-link" href={rankedProduct.product.offers.items[0].url} aria-label="link"/>
            <div className="ranked-item__details-button">
                <Link
                    size={'lg'}
                    uppercase={true}
                    color={'orange'}
                    block={true}
                    type={'button'}
                    href={rankedProduct.product.offers.items[0].url}
                >
                    Idź do sklepu
                </Link>
            </div>
            {rankedProduct.product.offers.count > 1 && (
                <Link className="ranked-item__details-offers" href={rankedProduct.product.url}>
                    {`Porównaj wszystkie oferty (${rankedProduct.product.offers.count})`}
                </Link>
            )}
        </div>

        <div className="ranked-item__details-mobile">
            <div className="details-mobile__title">
                Najniższa cena
            </div>
            <div className="details-mobile__info">
                <span>
                    {rankedProduct.product.offers.items[0].dealer.name}
                </span>
                <Price price={rankedProduct.product.price} weight={'700'} size={'md'}/>
            </div>
            <Link
                size={'xs'}
                color={'orange'}
                type={'button'}
                href={rankedProduct.product.offers.items[0].url}
                ariaLabel="Idz do oferty"
            >
                <i className="icon-arr2-right"/>
            </Link>
        </div>
    </ProductListImpression>
);

export default RankingItem;
